import { defineComponent, ref, computed } from "vue";
import { definePropType } from "@types-vue/props";
import { getProjectDemoPushLog } from "@/api/demo/project";
import TableList from "@/components/TableList/index.vue";
import { format } from "date-fns";
export default defineComponent({
    props: {
        project: {
            type: definePropType(Object),
            required: true
        }
    },
    components: {
        TableList: TableList
    },
    setup: function setup(props) {
        var showDialog = function showDialog() {
            visible.value = true;
            fetchList();
        };
        var fetchList = function fetchList() {
            loading.value = true;
            getProjectDemoPushLog({
                id: props.project.id
            }).then(function(res) {
                list.value = res.data.data.list || [];
            }).finally(function() {
                loading.value = false;
            });
        };
        var visible = ref(false);
        var loading = ref(true);
        // 表单数据
        var list = ref([]);
        var tableColumnConfig = computed(function() {
            return [
                {
                    label: "\u63A8\u9001\u9879\u76EEid",
                    prop: "copied_id",
                    width: 120,
                    align: "center"
                },
                {
                    label: "\u63A8\u9001\u5E7F\u544A\u4E3B\u540D\u79F0",
                    prop: "adv_name",
                    align: "center"
                },
                {
                    label: "\u63A8\u9001\u9879\u76EE\u540D\u79F0",
                    prop: "name",
                    align: "center"
                },
                {
                    label: "\u63A8\u9001\u65F6\u95F4",
                    prop: "created_time",
                    align: "center",
                    width: 130,
                    params: {
                        innerHTML: function innerHTML(param) {
                            var row = param.row;
                            var time = row.created_time ? "".concat(format(row.created_time * 1000, "YYYY/MM/DD HH:mm")) : "-";
                            return time;
                        }
                    }
                }, 
            ];
        });
        return {
            visible: visible,
            loading: loading,
            list: list,
            tableColumnConfig: tableColumnConfig,
            showDialog: showDialog,
            fetchList: fetchList
        };
    }
});
